import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/onboarding/2')({
  component: lazyRouteComponent(() => import('@/components/Onboarding/Onboarding2'), 'Onboarding2Component'),
});
